'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _lodash = require('lodash.clonedeep');

var _lodash2 = _interopRequireDefault(_lodash);

var _redux = require('redux');

var _pickup_station = require('../actions/pickup_station');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var INITIAL_STATE = {
    isFetching: false,
    didInvalidate: false,
    items: []
};
var pickupStations = function pickupStations() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
    var action = arguments[1];

    switch (action.type) {
        case _pickup_station.INVALIDATE_PICKUP_STATIONS:
            return _extends({}, state, {
                didInvalidate: true
            });
        case _pickup_station.REQUEST_PICKUP_STATIONS:
            return _extends({}, state, {
                isFetching: true,
                didInvalidate: false
            });
        case _pickup_station.RECEIVE_PICKUP_STATIONS:
            return _extends({}, state, {
                isFetching: false,
                didInvalidate: false,
                items: action.pickupStations,
                lastUpdated: action.received_at
            });
        case _pickup_station.FAILURE_PICKUP_STATIONS:
            return _extends({}, state, {
                isFetching: false,
                error: action.error
            });
        default:
            return state;
    }
};

var pickupStationReducer = (0, _redux.combineReducers)({
    pickupStations: pickupStations
});

exports.default = pickupStationReducer;


//////////////////
// WEBPACK FOOTER
// ./src/js/reducers/pickup_station.js
// module id = 897
// module chunks = 0